import Vue from 'vue';
import constants from '../../../../../../../constants';
import i18n from '../../../../plugins/i18n';

const showNotification = ({ type, title, message }) => {
  const text = i18n.translate(message) || (type === 'error' ? i18n.translate(constants.DEFAULT_ERROR_MESSAGE) : '');
  const notificationTitle = i18n.translate(title) || (type === 'error' ? i18n.translate(constants.DEFAULT_ERROR_TITLE) : '');
  Vue.notify({
    group: 'app',
    title: notificationTitle,
    type,
    text
    // duration: 1000000
  });
};
// #app > div.vue-notification-group > span > div > div.success
export default showNotification;
